
<div class="padding-20 ui-g" id="c3_searchProducts_Modal">
   
   <!-- Bottoni Annulla e Aggiungi -->
<div class="ui-dialog-footer fixed-buttons buttonsContainer">
  <button pButton (click)="onClickAnnullaProducts()" type="button" class="k-generic-btn footer-btn"
    label="{{'common.cancel' | translate}}"></button>
  <button pButton type="button" (click)="onClickAggiungiProducts()" class="k-generic-btn footer-btn"
    [disabled]="listProductSelected.length === 0" [ngClass]="{'not-allowed': listProductSelected.length === 0}"
    label="{{'common.confirm' | translate}}">
  </button>
  <div class="clear_fix"></div>
</div>

<br />
<br />
<br />


  <app-campaign-3-kontable 
  *ngIf="show.table"
  id="productsListTable"            
  [columns] = "[         
  { field: 'code', title: 'baskets.code' },
  { field: 'description', title: 'baskets.description' },
  { field: 'product_categories', title: 'baskets.category' },
  { field: 'product_department', title: 'baskets.department' },
  { field: 'barcode', title: 'baskets.barcode' }
]"
     
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [showSelectButton]="true"
  (onSelected)="onProductsSelected($event)"
  (onRefresh)="onRefreshTable($event)"
  (onTableRendered)="onTableRendered($event)"
  [rowSelected]="rowSelected"
  [source]="productsListAlreadySelected"
  #productsListTable>


</app-campaign-3-kontable>  
</div>


// WEBPACK FOOTER //
// ./src/app/views/baskets/remove-product-from-basket/remove-product-from-basket.component.html